const StructuralAccountType = {
    Tenant: 1,
    Suborg: 2,
    Location: 3
};

export { StructuralAccountType }